export enum BackgroundThemeTypes {
  TEAR = "TEAR",
  NONE = "NONE",
}
